import React from 'react'
import { MenuItem, Tab, Tabs, TextField } from '@mui/material'
import useIsMobile from '../hooks/useIsMobile'

const TabsOrMobileDropdown = ({ tabs, tab, setTab, override }) => {
  const isMobile = useIsMobile()

  if (isMobile || override)
    return (
      <TextField
        fullWidth
        select
        value={tab}
        onChange={(e) => setTab(e.target.value)}
      >
        {tabs.map((t, i) => (
          <MenuItem key={i} value={i}>
            {t.label}
          </MenuItem>
        ))}
      </TextField>
    )

  return (
    <Tabs
      variant='scrollable'
      sx={{}}
      value={tab}
      onChange={(_, val) => setTab(val)}
    >
      {tabs.map((t) => (
        <Tab key={t.label} label={t.label}></Tab>
      ))}
    </Tabs>
  )
}

export default TabsOrMobileDropdown
